import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-[var(--fx-r-md)] border border-[var(--fx-ink-200)] bg-white px-3 py-2 text-base text-[var(--fx-ink-900)] placeholder:text-[var(--fx-ink-500)]",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--fx-ink-900)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fx-accent-500)] focus-visible:ring-offset-1 focus-visible:border-[var(--fx-accent-500)]",
        "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "dark:bg-[var(--dk-surface)] dark:border-[var(--dk-border-2)] dark:text-[var(--dk-text)] dark:placeholder:text-[var(--dk-text-mute)]",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
